import { callFunction } from "./functions-client";

// Per-user Test-mode (sandbox) data. `ensure` is idempotent — it creates the user's isolated
// test identity + starter postings the first time they enter test mode. `reset` wipes that delta
// and re-creates it, so the user can start fresh after experimenting.

export const ensureSandbox = () =>
  callFunction<{ ready: boolean }>("sandbox/ensure", { body: {} });

export const resetSandbox = () =>
  callFunction<{ ready: boolean }>("sandbox/reset", { body: {} });
